import { useProviderLoginQuery } from '@/types/generated/graphql';
import { useDeviceStore } from '@modules/phone/store/device.store';
import { twilioProvider } from './adapter';

export const useProviderLogin = () => {
  const { initializeDevice, device, updateDeviceToken } = useDeviceStore();

  const setToken = (twilioToken?: string | null) => {
    const token = twilioToken + '';
    if (device) {
      twilioProvider.updateDeviceToken(device, token);
      updateDeviceToken(device);
    } else {
      initializeDevice(token);
    }
  };

  const { refetch } = useProviderLoginQuery({
    onCompleted: ({ providerLogin }) => {
      const twilioToken = providerLogin?.data?.token?.access;
      setToken(twilioToken);
    },
  });

  const refetchProviderLogin = async () => {
    try {
      const providerData = await refetch();
      const accessToken = providerData?.data?.providerLogin?.data?.token?.access;
      setToken(accessToken);
    } catch (error) {
      console.error(error);
    }
  };

  window.ononline = () => {
    refetchProviderLogin();
  };

  return {
    refetchProviderLogin,
  };
};
